import { useCallback, useEffect, useState } from 'react';
import { useApiClient } from '../lib/apiClient';

export function useMessageUnread(pollIntervalMs = 30000) {
  const { fetchJson } = useApiClient();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const payload = await fetchJson<{ data?: { totalUnread?: number } }>('/messages/unread');
      const next = payload?.data?.totalUnread ?? 0;
      setCount(next);
    } catch {
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [fetchJson]);

  useEffect(() => {
    let active = true;
    const tick = async () => {
      if (!active) return;
      await refresh();
    };
    void tick();
    const timer = window.setInterval(tick, pollIntervalMs);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [pollIntervalMs, refresh]);

  return { count, loading, refresh };
}
